"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteServiceImpl = void 0;
const createAutoCompleteResponse_1 = require("../transformers/autocompleteservice/createAutoCompleteResponse");
const constants_1 = require("../constants");
/**
* A service that performs query suggestions.
*/
class AutoCompleteServiceImpl {
    constructor(config, httpRequester) {
        var _a, _b, _c, _d, _e, _f;
        this.config = config;
        this.httpService = httpRequester;
        this.universalEndpoint = (_b = (_a = this.config.endpoints) === null || _a === void 0 ? void 0 : _a.universalAutoComplete) !== null && _b !== void 0 ? _b : constants_1.defaultEndpoints.universalAutoComplete;
        this.verticalEndpoint = (_d = (_c = this.config.endpoints) === null || _c === void 0 ? void 0 : _c.verticalAutoComplete) !== null && _d !== void 0 ? _d : constants_1.defaultEndpoints.verticalAutoComplete;
        this.filterEndpoint = (_f = (_e = this.config.endpoints) === null || _e === void 0 ? void 0 : _e.filterAutoComplete) !== null && _f !== void 0 ? _f : constants_1.defaultEndpoints.filterAutoComplete;
    }
    /**
     * Retrieves query suggestions for universal.
     *
     * @param {AutoCompleteRequest} request
     * @returns {Promise<AutoCompleteResponse>}
     */
    universalAutoComplete(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                input: request.input,
                experienceKey: this.config.experienceKey,
                api_key: this.config.apiKey,
                v: constants_1.defaultApiVersion,
                version: this.config.experienceVersion,
                locale: this.config.locale,
                sessionTrackingEnabled: request.sessionTrackingEnabled
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const rawUniversalAutocompleteResponse = yield this.httpService.get(this.universalEndpoint, queryParams);
            return createAutoCompleteResponse_1.createAutoCompleteResponse(rawUniversalAutocompleteResponse);
        });
    }
    /**
     * Retrieves query suggestions for a vertical.
     *
     * @param {VerticalAutoCompleteRequest} request
     * @returns {Promise<AutoCompleteResponse>}
     */
    verticalAutoComplete(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                input: request.input,
                experienceKey: this.config.experienceKey,
                api_key: this.config.apiKey,
                v: constants_1.defaultApiVersion,
                version: this.config.experienceVersion,
                locale: this.config.locale,
                verticalKey: request.verticalKey,
                sessionTrackingEnabled: request.sessionTrackingEnabled
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const rawVerticalAutocompleteResponse = yield this.httpService.get(this.verticalEndpoint, queryParams);
            return createAutoCompleteResponse_1.createAutoCompleteResponse(rawVerticalAutocompleteResponse);
        });
    }
    /**
     * Retrieves query suggestions for filter search.
     *
     * @param {FilterAutoCompleteRequest} request
     * @returns {Promise<AutoCompleteResponse>}
     */
    filterAutoComplete(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = this.getFilterSearchParams(request.searchParameters);
            const queryParams = {
                input: request.input,
                experienceKey: this.config.experienceKey,
                api_key: this.config.apiKey,
                v: constants_1.defaultApiVersion,
                version: this.config.experienceVersion,
                locale: this.config.locale,
                search_parameters: JSON.stringify(searchParams),
                verticalKey: request.verticalKey,
                sessionTrackingEnabled: request.sessionTrackingEnabled
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const rawFilterAutocompleteResponse = yield this.httpService.get(this.filterEndpoint, queryParams);
            return createAutoCompleteResponse_1.createFilterAutoCompleteResponse(rawFilterAutocompleteResponse);
        });
    }
    getFilterSearchParams(searchParams) {
        const convertedFields = searchParams.fields.map((field) => ({
            fieldId: field.fieldApiName,
            entityTypeId: field.entityType,
            shouldFetchEntities: field.fetchEntities
        }));
        const convertedSearchParams = {
            sectioned: searchParams.sectioned,
            fields: convertedFields
        };
        return convertedSearchParams;
    }
}
exports.AutoCompleteServiceImpl = AutoCompleteServiceImpl;
